"use client";
import React from "react";

export default function TermAndCond() {
  const pdfUrl = require("../../assets/static/POLITICADATOSDISEX2022.pdf");
  return (
    <section style={{ width: "100%", height: "100vh", backgroundColor: "#121212" }}>
      <div style={{ position: "relative", marginTop: "100px" }}>
      </div>
      <iframe
        src={pdfUrl}
        title="Política Datos Disex"
        width="100%"
        height="100%"
        contentEditable={false}
      />
    </section>
  );
}
